import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentReplace(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={76}
        height={94}
        x={50}
        y={13}
        stroke="url(#DocumentReplace_svg__a)"
        strokeWidth={10}
        rx={16}
      />
      <path stroke="#0D2B57" strokeLinecap="round" d="M67.5 34.5h41m-41 10h41" />
      <rect width={39} height={39} x={106} y={54.5} fill="#0D2B57" rx={19.5} />
      <rect width={39} height={39} x={106} y={54.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M118.417 75.25v-5a2.5 2.5 0 0 1 2.5-2.5h7.916m-2.083-2.5 2.5 2.5-2.5 2.5m5.833 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-7.916m2.083 2.5-2.5-2.5 2.5-2.5"
      />
      <defs>
        <linearGradient
          id="DocumentReplace_svg__a"
          x1={88}
          x2={88}
          y1={13}
          y2={107}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentReplace);
export default ForwardRef;
